/**
 * Material type enumeration
 */
export const MaterialType = {
    PDF: 'PDF',
};

/**
 * Get all material types as an array
 * @returns {string[]}
 */
export const getMaterialTypes = () => Object.values(MaterialType);

/**
 * Check if a type is valid
 * @param {string} type
 * @returns {boolean}
 */
export const isValidMaterialType = (type) => Object.values(MaterialType).includes(type);
